/**
 * FAQ accordion — single-open, CSS grid-template-rows height animation.
 *
 * Accessibility:
 *  - <button aria-expanded aria-controls> on the toggle
 *  - <div role="region" aria-label> on the body panel
 *  - No hidden attribute: content remains in the accessibility tree;
 *    aria-expanded on the trigger is the primary state signal.
 *
 * Animation:
 *  - grid-template-rows: 0fr → 1fr via CSS transition (defined in _faq.scss)
 *  - prefers-reduced-motion: transition: none handled in CSS
 */

const openItem = (item) => {
	const toggle = item.querySelector('.js-faq-toggle');
	if (!toggle) return;

	item.classList.add('is-open');
	toggle.setAttribute('aria-expanded', 'true');
};

const closeItem = (item) => {
	const toggle = item.querySelector('.js-faq-toggle');
	if (!toggle) return;

	item.classList.remove('is-open');
	toggle.setAttribute('aria-expanded', 'false');
};

/**
 * @param {HTMLElement} section
 */
const bindSection = (section) => {
	const items = section.querySelectorAll('.js-faq-item');
	if (!items.length) return;

	items.forEach((item) => {
		const toggle = item.querySelector('.js-faq-toggle');
		if (!toggle) return;

		toggle.addEventListener('click', () => {
			const isOpen = item.classList.contains('is-open');

			items.forEach((other) => {
				if (other !== item && other.classList.contains('is-open')) {
					closeItem(other);
				}
			});

			if (isOpen) {
				closeItem(item);
			} else {
				openItem(item);
			}
		});
	});
};

export const initFaqAccordion = () => {
	const sections = document.querySelectorAll('.js-faq-section, .js-services-faq-section');
	if (!sections.length) return;

	sections.forEach(bindSection);
};
